import axiosInstance from '../api/axiosInstance';
import { API_ENDPOINTS } from '../api/config';

export type BookingStatus = 'pending' | 'upcoming' | 'completed' | 'cancelled';
export type BookingBucket = 'upcoming' | 'completed' | 'cancelled';
export type BookingKind = 'booking' | 'entitlement';
export type BookingPaymentStatus =
  | 'paid'
  | 'unpaid'
  | 'refunded'
  | 'waived'
  | 'failed'
  | 'not_applicable';
export type BookingAction = 'pay' | 'join' | 'reschedule' | 'cancel';

export interface Booking {
  id: string;
  service: string;
  service_label: string;
  kind: BookingKind;
  reference: string;
  title: string;
  participant_name: string;
  date: string | null;
  date_has_time: boolean;
  end_date: string | null;
  status: BookingStatus;
  status_label: string;
  status_source: string;
  bucket: BookingBucket;
  amount: string | null;
  currency: string;
  payment_status: BookingPaymentStatus;
  actions: BookingAction[];
  detail_url: string;
}

export interface BookingServiceOption {
  key: string;
  label: string;
}

export interface BookingPage {
  count: number;
  next: string | null;
  previous: string | null;
  results: Booking[];
  services: BookingServiceOption[];
}

export interface BookingsParams {
  status?: BookingBucket | 'pending' | 'all';
  service?: string;
  kind?: BookingKind;
  from_date?: string;
  to_date?: string;
  ordering?: 'date' | '-date' | 'end_date' | '-end_date';
  page?: number;
  page_size?: number;
}

const emptyPage: BookingPage = {
  count: 0,
  next: null,
  previous: null,
  results: [],
  services: [],
};

const bookingsService = {
  getBookings: async (params?: BookingsParams): Promise<BookingPage> => {
    const response = await axiosInstance.get(API_ENDPOINTS.myBookings, { params });
    const data = response.data;
    if (!data || Array.isArray(data)) {
      return emptyPage;
    }
    return {
      count: data.count ?? 0,
      next: data.next ?? null,
      previous: data.previous ?? null,
      results: data.results ?? [],
      services: data.services ?? [],
    };
  },
};

export default bookingsService;
